export const loadAboutPage = () => import("@/pages/AboutPage");
export const loadServicesPage = () => import("@/pages/ServicesPage");
export const loadProjectsPage = () => import("@/pages/ProjectsPage");
export const loadProjectDetailPage = () => import("@/pages/ProjectDetailPage");
export const loadContactPage = () => import("@/pages/ContactPage");
export const loadDreamsPage = () => import("@/pages/DreamsPage");
export const loadPrivacyPolicyPage = () => import("@/pages/PrivacyPolicyPage");
export const loadTermsOfUsePage = () => import("@/pages/TermsOfUsePage");

export const warmRouteChunks = () => {
  const tasks = [
    loadProjectsPage,
    loadAboutPage,
    loadServicesPage,
    loadContactPage,
    loadDreamsPage,
    loadProjectDetailPage,
  ];

  tasks.forEach((task, index) => {
    window.setTimeout(task, 60 * (index + 1));
  });
};

const HERO_SRCS = [
  "/images/3-hakkimizda/hakkimizda_opt.webp",
  "/images/4-hizmetler/hizmetler_opt.webp",
  "/images/6-iletisim/iletisim_opt.webp",
  "/images/7-dreams/dreams_opt.webp",
];

export const warmHeroImages = () => {
  const preload = () => {
    HERO_SRCS.forEach((src, i) => {
      window.setTimeout(() => {
        const img = new window.Image();
        img.src = src;
      }, i * 200);
    });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(preload, { timeout: 3000 });
  } else {
    window.setTimeout(preload, 800);
  }
};
